import { FunctionComponent } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router";

import WebtieLogo from "../webtie-logo.png";
import { SpielgruppePlusIcon } from "../SpielgruppePlusIcon";

interface Props {
  userId?: string;
}

export const Footer: FunctionComponent<Props> = ({ userId }) => {
  return (
    <Col className={"footer pt-5 mt-5"}>
      <Container>
        <Row>
          <Col md={4} sm={12}>
            <div className="footer-item text-start">
              <h4>Weitere Links</h4>
              <p>
                <a href="https://www.webtie.ch" target={"_blank"}>
                  webtie.ch
                </a>
                <br />
                <a href="https://www.webtie.ch/#contact" target={"_blank"}>
                  Kontakt aufnehmen
                </a>
                <br />
                <Link to="/datenschutz">Datenschutz</Link>
                <br />
                {userId && (
                  <>
                    <Link to={`/user/${userId}/plus`} className="d-inline-flex align-items-center text-primary">
                      <SpielgruppePlusIcon style={{ marginRight: 8 }} />
                      Spielgruppe Plus
                    </Link>
                    <br />
                  </>
                )}
              </p>
            </div>
          </Col>
          <Col md={4} sm={12}>
            <div className="footer-item text-start">
              <h4>Kontaktangaben</h4>
              <p>
                <a href={"https://www.webtie.ch"} target={"_blank"}>
                  webtie gmbh
                </a>
                <br />
                Ölermattstrasse 2
                <br />
                5116 Schinznach Bad
              </p>
            </div>
          </Col>
          <Col md={4} sm={12} className={"footer-logo-div text-end"}>
            <img
              width={250}
              height={"auto"}
              alt={"Logo von webtie.ch"}
              src={WebtieLogo}
              className={"img-fluid footer-logo"}
            />
          </Col>
        </Row>
        <hr className="half-rule" />
        <Row>
          <Col className={"col-12 sub-footer"}>
            <p className={"text-end"}>&#169; {new Date().getFullYear()} webtie.ch. All rights reserved</p>
          </Col>
        </Row>
      </Container>
    </Col>
  );
};
